export default "__VITE_ASSET__5a1d895d__"